<template>
  <q-dialog
    v-model="isShowing"
    persistent
  >
    <q-card class="q-pa-md">
      <q-card-section>
        <div class="text-body1 text-center q-mb-lg">
          {{ $t('payment.valitorPage.hint') }}
        </div>

        <div v-if="$q.platform.is.cordova && fields">
          <div class="text-center q-mb-lg">
            <q-btn
              v-close-popup
              class="on-left"
              :label="$t('payment.valitorPage.cancel')"
              @click="hide"
            />

            <q-btn
              v-close-popup
              color="secondary"
              :label="$t('payment.valitorPage.submit')"
              @click="postForm"
            />
          </div>
        </div>

        <q-form
          v-else-if="fields"
          :action="url"
          method="post"
          target="_blank"
          rel="noreferrer"
          class="q-mb-lg"
        >
          <div
            v-for="([name, value], index) in Object.entries(fields)"
            :key="index"
            class="hidden"
          >
            <q-input
              v-if="value"
              type="hidden"
              :name="name"
              :value="value"
            />
          </div>

          <div class="text-center">
            <q-btn
              v-close-popup
              class="on-left"
              :label="$t('payment.valitorPage.cancel')"
              @click="hide"
            />

            <q-btn
              v-close-popup
              type="submit"
              color="secondary"
              :label="$t('payment.valitorPage.submit')"
            />
          </div>
        </q-form>

        <div class="text-body1 text-center">
          {{ $t('payment.valitorPage.footer') }}
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PaymentValitorPageForm',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      isShowing: false,
    };
  },

  watch: {
    show(value) {
      this.isShowing = value;
    },
  },

  methods: {
    hide() {
      this.isShowing = false;
      this.$emit('close');
    },

    postForm() {
      if (this.$q.platform.is.cordova) {
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', this.url);
        form.setAttribute('name', 'form');

        Object.entries(this.fields).forEach(([name, value]) => {
          const hiddenField = document.createElement('input');
          hiddenField.setAttribute('type', 'hidden');
          hiddenField.setAttribute('name', name);
          hiddenField.setAttribute('value', value);
          form.appendChild(hiddenField);
        });

        const html = document.createElement('html');
        const body = document.createElement('body');
        body.appendChild(form);
        body.setAttribute('onload', 'document.form.submit();');
        html.appendChild(body);

        const ref = cordova.InAppBrowser.open(
          `data:text/html;base64,${btoa(html.innerHTML)}`,
          '_blank',
          'hidden=no,location=no,clearsessioncache=yes,clearcache=yes',
        );

        if (ref) {
          form.submit();
        }
      }
    },
  },
};
</script>
